import { PureComponent } from 'react';

class ScrollToTop extends PureComponent {
	componentDidMount() {
		if (window) {
			if (this.props.smooth) {
				window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
			} else {
				window.scrollTo(0, 0);
			}
		}
	}

	render() {
		return null;
	}
}

export default ScrollToTop;
